import { createApp } from 'vue'
import App from './App.vue';
import router from './router';
import store from './store';
import "./permission";
import directives from "@/directives";
import "@/assets/css/common.scss";
import "@/assets/icon/iconfont.css";
// collapse
import { ElCollapseTransition } from 'element-plus'
// fade/zoom
// import 'element-plus/lib/theme-chalk/base.css'
import 'element-plus/es/components/message/style/css';
import 'element-plus/es/components/notification/style/css';
import 'element-plus/es/components/message-box/style/css';
import { get, post, put, del, patch, File, upload } from "@/assets/Api";
import mitt from 'mitt'
import * as ELIcons from '@element-plus/icons-vue';
// import 'lib-flexible'; 移动端适配
import "@/utils/remFn";
import { directives_ } from "@/utils/directive";



const app = createApp(App);

for (let iconName in ELIcons) {
    app.component(iconName, ELIcons[iconName])
}

app.config.globalProperties.$get= get;
app.config.globalProperties.$post= post;
app.config.globalProperties.$put= put;
app.config.globalProperties.$patch= patch;
app.config.globalProperties.$del= del;
app.config.globalProperties.$file = File;
app.config.globalProperties.$upload = upload;
app.config.globalProperties.$mitt = mitt();
app.component(ElCollapseTransition.name, ElCollapseTransition)
    .use(directives)
    .use(store)
    .use(router)
    .use(directives_)
    .mount('#app')
